import { Callable } from '@prophecy/interfaces/generic';
import { noop } from 'lodash-es';

import { OAuthCallbackKey, OAuthSamlCallbackKey } from './constants';

/**
 * Post a message to the opener window
 * @param type - The type of the message to post
 * @param payload - The payload of the message to post
 */
export const postMessageToOpener = <T>(type: string, payload: T) => {
  window.opener?.window.postMessage({ type, payload }, window.location.origin);
};

export const openWindow = (
  url: string,
  {
    events,
    onUnload
  }: {
    events?: Record<string, Callable>;
    onUnload?: Callable;
  } = {}
) => {
  let openerWindow: WindowProxy | null = null;

  const closeWindow = () => {
    window.removeEventListener('message', callbackFunc);
    // oxlint-disable-next-line no-unused-expressions
    onUnload && openerWindow?.removeEventListener('unload', onUnload);
    openerWindow?.close();
  };

  const callbackFunc = (event: MessageEvent) => {
    if (event.origin !== window.location.origin) {
      return;
    }

    if (events?.[event.data.type]) {
      events[event.data.type](event.data.payload);
    }
  };

  window.addEventListener('message', callbackFunc, false);
  openerWindow = window.open(url, '_blank');
  openerWindow?.focus();
  // oxlint-disable-next-line no-unused-expressions
  onUnload && openerWindow?.addEventListener('unload', onUnload);

  return {
    closeWindow,
    isOpen: () => openerWindow && !openerWindow.closed
  };
};

export const openOauthWindow = (url: string, callback: Callable = noop, toggleLoader?: Function) => {
  const { closeWindow } = openWindow(url, {
    events: {
      [OAuthCallbackKey]: (payload) => {
        closeWindow();
        callback(payload);
      },
      [OAuthSamlCallbackKey]: (payload) => {
        closeWindow();
        callback(payload);
      }
    },
    onUnload: () => {
      // Switch off loader after 2s once action is completed
      setTimeout(() => {
        toggleLoader?.();
      }, 2000);
    }
  });

  return closeWindow;
};
